import { Box, GridItem, Image } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { SelfieItemProps } from "../../interfaces/SelfieItemProps";
import { AppDispatch } from "../../reducers/configureStore";
import { setSelectedSelfie } from "../../reducers/selfie/selfieSlice";

export const SelfieItem = (props: SelfieItemProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const selectSelfie = (id: string) => {
    dispatch(setSelectedSelfie(id));
  };

  return (
    <GridItem
      onClick={() => selectSelfie(props.id)}
      border={props.selected ? "2px solid #000000" : "none"}
    >
      <Box
        _hover={{ bgSize: "110%" }}
        key={props.id}
        bg="#000000"
        position="relative"
        cursor="pointer"
        overflow="hidden"
        minH="120px"
        maxH="120px"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Image
          src={props.thumbnailUrl}
          _hover={{ transform: "scale(1.1)" }}
          transition="transform 0.2s ease-in-out"
        />
      </Box>
    </GridItem>
  );
};
